import {useGameStore} from '../GameStoreContext.ts'

export const useIsMyVotePending = () => {
    const voteState = useGameStore((state) => state.gameVote.voteState)
    const myColor = useGameStore((state) => state.myColor)

    if(voteState === undefined) return false

    const allVotes = [...voteState.acceptedVotes, ...voteState.declinedVotes]
    return !allVotes.includes(myColor)
}
